import React, { Component } from 'react';
import { Button } from '@mui/material';
//import ReactTooltip from "react-tooltip";

import AddIcon from '../images/add.png';
import DeleteIcon from '../images/delete.png';
import DollarIcon from '../images/dollar-icon.png';
import EditIcon from '../images/edit-icon.png';
import EmailIcon from '../images/email-icon.png';
import SearchIcon from '../images/search-icon.png';
import { GetCookie } from './utils/Common';

const moment = require('moment');

export class AddressInfoCellRenderer extends Component {
  render() {
    const { data } = this.props;
    return (
      <div>
        {data.aptStreet}
        <br />
        {data.aptCity} {data.aptState} {data.aptZip}
      </div>
    );
  }
}

export class AuditFlgCellRenderer extends Component {
  render() {
    const { data } = this.props;
    const displayText = data.auditFlg === true ? 'Yes' : 'No';

    return <td className="x-grid-cell-inner">{displayText}</td>;
  }
}

export class AddFollowUpCellRenderer extends React.Component {
  handleClick = () => {
    const { data, context } = this.props;
    context.addSchedule(data, context.rowIndex); // Assuming you pass these functions via context
    context.setModal();
  };

  render() {
    return (
      <img
        src={AddIcon}
        style={{ width: '16px', height: '16px', cursor: 'pointer' }}
        alt="Add"
        onClick={this.handleClick}
      />
    );
  }
}

export class ClmConfCellRenderer extends Component {
  render() {
    const { value } = this.props; // `value` is automatically provided by ag-Grid

    return (
      <span style={{ paddingRight: '40px' }}>
        {value === true ? 'Yes' : <span style={{ color: 'red' }}>No</span>}
      </span>
    );
  }
}

export class ClaimantNameCellRenderer extends Component {
  render() {
    const { data } = this.props; // ag-Grid passes the data prop automatically to the renderer
    const name = `${data.clmLastName}, ${data.clmFirstName}`;

    if (data.hasClaimantDupWO) {
      return <span style={{ color: 'red' }}>{name}</span>;
    } else {
      return <span>{name}</span>;
    }
  }
}

export class CalendarDateCellRenderer extends React.Component {
  render() {
    const { value } = this.props;
    return (
      <span>
        {moment(value).format('MM/DD/YYYY')}{' '}
        {
          this.props.context.componentParent.props.state.dayNames[
            moment(value).day()
          ]
        }
      </span>
    );
  }
}

export class CreatedByCellRenderer extends Component {
  render() {
    const { data } = this.props;
    const name = `${data.firstName} ${data.lastName}`;
    return <span>{name}</span>;
  }
}

export class CurrencyCellRenderer extends React.Component {
  render() {
    const value = this.props.value;
    return <span>{value === null ? '' : `$${value}`}</span>;
  }
}

export class DateCellRenderer extends React.Component {
  render() {
    let formattedDate = '';
    if (this.props.value) {
      formattedDate = moment(this.props.value).format('MM/DD/YYYY');
    }
    return <div style={{ width: '200px' }}>{formattedDate}</div>;
  }
}

export class DeleteCellRenderer extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <button
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
        }}
      >
        <img
          src={DeleteIcon}
          style={{ width: '14px', height: '14px', cursor: 'pointer' }}
          onClick={() => this.props.context.handleDeleteJobHistory(data)}
          alt="Delete"
        />
      </button>
    );
  }
}

export class DetailCellRenderer extends React.Component {
  renderFollowUpDescription(description, context) {
    if (!description) return '';

    const match = description.match(/\[\s*([^\]]+)\s*\](.*)/);
    const jobNum = match ? match[1].trim() : null;
    const remainingText = match ? match[2] : description;

    if (!jobNum || !context || typeof context.handleOpenJobFromHistory !== 'function') {
      return description;
    }

    const handleClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      context.handleOpenJobFromHistory(jobNum);
    };

    return (
      <>
        <button
          type="button"
          onClick={handleClick}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            color: 'blue',
            textDecoration: 'underline',
            cursor: 'pointer',
            font: 'inherit',
          }}
        >
          [{jobNum}]
        </button>
        {remainingText}
      </>
    );
  }

  render() {
    const { data, context, value } = this.props;
    const style = {
      color:
        data.jobHistoryType === 'Schedule Change'
          ? 'green'
          : data.jobHistoryType === 'Special Billing'
          ? 'red'
          : 'black',
    };

    const description =
      value !== undefined && value !== null
        ? String(value)
        : data.description || data.Description || '';
    const descriptionContent =
      data.jobHistoryType === 'Follow Up'
        ? this.renderFollowUpDescription(description, context)
        : description;

    return (
      <span
        data-for="rtp2"
        style={style}
        name="rtp2"
        data-tip={description}
        title={description}
      >
        {/* The file link leads so a long description, cut off by the column, can't hide it. */}
        {data.fileLocation !== '' && data.fileLocation !== 'null' && data.fileName && data.fileName !== 'null' && (
          <>
            <button
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                color: 'blue',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={() => this.props.context.handleViewJobHistoryFile(data)}
            >
              {data.fileName}
            </button>
            &nbsp;
          </>
        )}
        {descriptionContent}
      </span>
    );
  }
}

export class DurationCellRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      duration: this.calculateDuration(
        props.data.jobDateTime,
        props.data.finishTime,
        props.data.failedFlg
      ),
    };
  }

  calculateDuration(jobDateTime, finishTime, failedFlg) {
    if (failedFlg === true) {
      return 'FAIL';
    } else {
      if (!jobDateTime || !finishTime) return '';

      let startDate = new Date(jobDateTime);
      let finishDate = new Date(finishTime);

      // Extract hours and minutes to compare only the time portion
      let start = startDate.getHours() * 60 + startDate.getMinutes();
      let finish = finishDate.getHours() * 60 + finishDate.getMinutes();

      // Check if the start and finish times are the same, ignoring the date
      if (start === finish) {
        return '00:00';
      }

      // Handle crossing over midnight
      if (finish < start) {
        finish += 1440; // Add 24 hours worth of minutes
      }

      let durationMinutes = finish - start;
      let hoursDiff = Math.floor(durationMinutes / 60);
      let minutesDiff = durationMinutes % 60;

      return `${String(hoursDiff).padStart(2, '0')}:${String(
        minutesDiff
      ).padStart(2, '0')}`;
    }
  }

  render() {
    const durationStyle = {
      color: this.state.duration === 'FAIL' ? 'red' : 'black',
    };

    return (
      <div className="x-grid-cell-inner" style={durationStyle}>
        {this.state.duration}
      </div>
    );
  }
}

export class EditViewCellRenderer extends React.Component {
  render() {
    const { data, context } = this.props;
    const user = JSON.parse(GetCookie('user'));

    // Check if this is a 'MyJob' note created by someone else
    // Try both possible property names for createByUserId
    const createByUserId = data.createByUserId || data.createbyUserId;
    const isMyJobByOtherUser =
      data.jobHistoryType === 'My Job' &&
      user &&
      user.userid !== createByUserId;

    // If it's a MyJob note by another user, only show 'View'
    if (isMyJobByOtherUser) {
      return (
        <button
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            color: 'blue',
            textDecoration: 'underline',
            cursor: 'pointer',
            font: 'inherit',
          }}
          onClick={() => this.props.context.handleNewJobNoteViewClick(data)}
        >
          View
        </button>
      );
    }

    return (
      <button
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          color: 'blue',
          textDecoration: 'underline',
          cursor: 'pointer',
          font: 'inherit',
        }}
        onClick={() => this.props.context.handleNewJobNoteViewClick(data)}
      >
        {data.jobHistoryType === 'Int Communication' ||
        data.jobHistoryType === 'Job Note' ||
        data.jobHistoryType === 'My Job'
          ? 'Edit'
          : 'View'}
      </button>
    );
  }
}

export class EditCellRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.onEditClicked = this.onEditClicked.bind(this);
  }

  onEditClicked() {
    this.props.context.handleEdit(this.props.data);
  }

  render() {
    return (
      <center>
        <img
          src={EditIcon}
          onClick={this.onEditClicked}
          style={{ width: '16px', cursor: 'pointer' }}
          alt="Edit"
        />
      </center>
    );
  }
}

export class EditDeleteCellRenderer extends React.Component {
  render() {
    const { data } = this.props;

    // Check if the row is a pinned bottom row
    if (this.props.node.rowPinned) {
      return null; // Return null to render nothing for pinned rows
    }

    return (
      <div>
        <img
          src={EditIcon}
          onClick={() => this.props.context.handleEditJobDescriptionClick(data)}
          style={{ width: '16px', height: '16px', cursor: 'pointer' }}
          alt="Edit"
        />{' '}
        <img
          src={DeleteIcon}
          onClick={() => {
            if (window.confirm('Are you sure to delete this record?')) {
              this.props.context.handleDeleteJobDescriptionClick(data);
            }
          }}
          style={{ width: '16px', height: '16px', cursor: 'pointer' }}
          alt="Delete"
        />
      </div>
    );
  }
}

export class JobDateCellRenderer extends Component {
  render() {
    const { data } = this.props;
    const jobDate = data.jobDateTime
      ? moment(data.jobDateTime).format('MM/DD/YYYY hh:mm A')
      : '';
    const finishTime = data.finishTimeString
      ? ' to ' + data.finishTimeString
      : '';
    return (
      <>
        <span data-for="jobDateTooltip">
          {jobDate} {finishTime}
        </span>
      </>
    );
  }
}

export class JobDateSuccessCellRenderer extends React.Component {
  render() {
    const { data } = this.props;
    const jobDateTime = data.jobDateTime
      ? moment(data.jobDateTime).format('MM/DD/YYYY hh:mm A')
      : '';
    const finishTime = data.finishTime
      ? moment(data.finishTime).format('hh:mm A')
      : '';
    const status = data.failedFlg === true ? ' (Failed)' : ' (Success)';
    const jobTimeRange = `${jobDateTime} ${
      finishTime ? `to ${finishTime}` : ''
    } ${status}`;

    return <span>{jobTimeRange}</span>;
  }
}

export class JobHistoryCellRenderer extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { data } = this.props;
    // Assuming you have a method to view job history
    this.props.context.viewJobHistory(data);
  }

  render() {
    return (
      <div style={{ textAlign: 'center' }}>
        <img
          src={SearchIcon}
          onClick={this.handleClick}
          style={{ width: '16px', height: '16px', cursor: 'pointer' }}
          alt="Job History"
        />
      </div>
    );
  }
}

export class JobNumCellRenderer extends Component {
  handleClick = (e) => {
    e.stopPropagation();
    const { data, context } = this.props;
    context.componentParent.props.viewInvoice(data);
  };

  render() {
    const { value } = this.props;

    return (
      <span
        onClick={this.handleClick}
        style={{
          cursor: 'pointer',
          color: 'blue',
          textDecoration: 'underline',
        }}
      >
        {value}
      </span>
    );
  }
}

export class JobNotesCellRenderer extends Component {
  handleClick = () => {
    const { data, context } = this.props;
    context.componentParent.props.viewJobNotes(data);
  };

  render() {
    return (
      <img
        src={DollarIcon}
        style={{ width: '16px', height: '16px', cursor: 'pointer' }}
        alt="Add"
        onClick={this.handleClick}
      />
    );
  }
}

// Custom cell renderer for Job Type
export class JobTypeCellRenderer extends Component {
  render() {
    const { value, context, data } = this.props;
    let jobTypeList =
      (context &&
        context.componentParent &&
        context.componentParent.state.jobTypeList) ||
      (data && data.jobTypeList) ||
      [];

    // Try both possible property names for the ID field
    const normalizedValue = value != null ? String(value).trim() : '';
    const match = jobTypeList.find((jt) => {
      // Try both jobinvlinecodeid and jobInvLineCodeId
      const id1 =
        jt.jobinvlinecodeid !== undefined
          ? String(jt.jobinvlinecodeid).trim()
          : null;
      const id2 =
        jt.jobInvLineCodeId !== undefined
          ? String(jt.jobInvLineCodeId).trim()
          : null;
      return id1 === normalizedValue || id2 === normalizedValue;
    });

    return match && match.appointmentType ? match.appointmentType : '';
  }
}

export class FuCellRenderer extends Component {
  render() {
    const { data } = this.props; // `value` is automatically provided by ag-Grid
    return <span style={{ paddingRight: '40px' }}>{data.fu}</span>;
  }
}

export class FollowupDateCellRenderer extends Component {
  render() {
    const { data } = this.props;
    const followupDate = data.followupDate
      ? moment(data.followupDate).format('MM/DD/YYYY hh:mm A')
      : '';

    return (
      <>
        <span>{followupDate}</span>
      </>
    );
  }
}

export class IntCheckInCellRenderer extends React.Component {
  handleIntCheckin = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { data, context } = this.props;
    context.componentParent.props.handleIntCheckin(data);
  };

  render() {
    const { data } = this.props; // Ag-Grid passes the row data as 'data'
    const { inHouseFlg, finishTime } = data;

    let content;
    if (inHouseFlg === true && finishTime === null) {
      content = 'NB';
    } else if (inHouseFlg === false && finishTime === null) {
      content = (
        <span>
          <button
            onClick={(e) => this.handleIntCheckin(e)}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              color: 'blue',
              textDecoration: 'underline',
              cursor: 'pointer',
              font: 'inherit',
            }}
          >
            NC
          </button>
        </span>
      );
    } else if (finishTime !== null) {
      content = 'CO';
    } else {
      content = null;
    }

    return <span className="x-grid-cell-inner">{content}</span>;
  }
}

export class IntConfCellRenderer extends React.Component {
  handleIntConfNo = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { data, context } = this.props;
    context.componentParent.props.handleIntConfNo(data);
  };

  handleSendSMS = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { data, context } = this.props;
    context.componentParent.props.handleSendSMS(data);
  };

  render() {
    const { data } = this.props;
    return (
      <div className="x-grid-cell-inner">
        <span style={{ paddingRight: '40px' }}>
          {data.intConfFlg === true ? (
            'Yes'
          ) : (
            <span>
              {/* Call the methods correctly using arrow functions */}
              <button
                onClick={(e) => this.handleIntConfNo(e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  color: 'blue',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  font: 'inherit',
                }}
              >
                No
              </button>{' '}
              |
              <button
                onClick={(e) => this.handleSendSMS(e)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  color: 'blue',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  font: 'inherit',
                }}
              >
                Send SMS
              </button>
            </span>
          )}
        </span>
      </div>
    );
  }
}

export class IntEmailCellRenderer extends Component {
  handleClick = () => {
    const { data, context } = this.props;
    context.componentParent.props.setInterpreterEmail(data);
  };

  render() {
    return (
      <img
        src={EmailIcon}
        style={{ width: '16px', height: '16px', cursor: 'pointer' }}
        alt="Email"
        onClick={this.handleClick}
      />
    );
  }
}
export class IntNameCellRenderer extends Component {
  handleClick = () => {
    const { data, context } = this.props;
    context.componentParent.props.openInterpreter(data.intId);
  };

  render() {
    const { data } = this.props; // ag-Grid passes the data prop automatically to the renderer
    const name = `${data.intLastName}, ${data.intFirstName}`;
    if (data.hasInterpreterDupWO) {
      return (
        <span
          onClick={this.handleClick}
          style={{
            cursor: 'pointer',
            color: 'red',
            textDecoration: 'underline',
          }}
        >
          {name}
        </span>
      );
    } else {
      return (
        <span
          onClick={this.handleClick}
          style={{
            cursor: 'pointer',
            color: 'blue',
            textDecoration: 'underline',
          }}
        >
          {name}
        </span>
      );
    }
  }
}

export class InvoicedFlgCellRenderer extends Component {
  render() {
    const { data } = this.props;
    if (data.invoicedFlg) {
      return <span>P</span>;
    } else {
      return <span></span>;
    }
  }
}

export class PartialDayCellRenderer extends React.Component {
  render() {
    const { value } = this.props;
    return <span>{value ? 'Yes' : 'No'}</span>;
  }
}

export class ProvConfCellRenderer extends Component {
  render() {
    const { value } = this.props; // `value` is automatically provided by ag-Grid

    return (
      <span style={{ paddingRight: '40px' }}>
        {value === true ? 'Yes' : <span style={{ color: 'red' }}>No</span>}
      </span>
    );
  }
}

export class ProviderEmailCellRenderer extends Component {
  handleClick = () => {
    const { data, context } = this.props;
    context.componentParent.props.setProviderEmail(data);
  };

  render() {
    return (
      <img
        src={EmailIcon}
        style={{ width: '16px', height: '16px', cursor: 'pointer' }}
        alt="Email"
        onClick={this.handleClick}
      />
    );
  }
}

export class ProviderNameCellRenderer extends Component {
  render() {
    const { data } = this.props; // ag-Grid passes the data prop automatically to the renderer
    const name = `${data.providerName} (${data.aptCity})`;
    return <span>{name}</span>;
  }
}

export class RemFinalConfCellRenderer extends Component {
  render() {
    const { value } = this.props; // `value` is automatically provided by ag-Grid

    return (
      <span style={{ paddingRight: '40px' }}>
        {value === true ? 'Yes' : <span style={{ color: 'red' }}>No</span>}
      </span>
    );
  }
}

export class RepEmailCellRenderer extends Component {
  handleClick = () => {
    const { data, context } = this.props;
    context.componentParent.props.setRepEmail(data);
  };

  render() {
    return (
      <img
        src={EmailIcon}
        style={{ width: '16px', height: '16px', cursor: 'pointer' }}
        alt="Email"
        onClick={this.handleClick}
      />
    );
  }
}

export class RepAuthorizedCellRenderer extends Component {
  render() {
    const { value } = this.props; // `value` is automatically provided by ag-Grid

    return (
      <span style={{ paddingRight: '40px' }}>
        {value === true ? 'Yes' : <span style={{ color: 'red' }}>No</span>}
      </span>
    );
  }
}

export class RepEmail2CellRenderer extends Component {
  handleClick = () => {
    const { data, context } = this.props;
    context.componentParent.props.setRepEmail2(data);
  };

  render() {
    return (
      <img
        src={EmailIcon}
        style={{ width: '16px', height: '16px', cursor: 'pointer' }}
        alt="Email"
        onClick={this.handleClick}
      />
    );
  }
}

export class RepNameCellRenderer extends Component {
  render() {
    const { data } = this.props; // ag-Grid passes the data prop automatically to the renderer
    const name = `${data.repLastName}, ${data.repFirstName} (${data.clientAbbrv})`;
    return <span>{name}</span>;
  }
}

export class TransportationCellRenderer extends Component {
  render() {
    const { transportationFlg, transConfFlg } = this.props.data;

    let content;
    if (transportationFlg && transConfFlg) {
      content = <span style={{ color: 'red' }}>T</span>; // Both flags are true, show 'T' in red
    } else if (transportationFlg && !transConfFlg) {
      content = 'T'; // Only transportationFlg is true, show 'T' in default color
    } else {
      content = ''; // Neither condition met, show empty
    }

    return <span>{content}</span>;
  }
}

export class UserInactiveCellRenderer extends Component {
  render() {
    const { disabledFlg } = this.props.data;
    const isDisabled = disabledFlg === true;

    return (
      <span
        style={{
          backgroundColor: isDisabled ? null : 'green',
          color: isDisabled ? 'black' : 'white',
          padding: '0 6px',
          borderRadius: '2px',
        }}
      >
        {isDisabled ? 'InActive' : 'Active'}
      </span>
    );
  }
}
